<template>
  <el-container style="height:100%;">
    <el-main class="padding-content">
      <el-input class="input-with-select" size="small" placeholder="关键字查询" clearable v-model="filterText" style="margin-bottom: 4px;">
        <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
      </el-input>
      <div v-if="showAll" class="rptTopButtonDiv">
        <button class="allNodeBtn" @click="allNodeClick">
          <div v-if="showCheckbox" style="margin-right: 8px;">
            <el-checkbox disabled></el-checkbox>
          </div>
          <span style="font-size: 14px;">{{ allText }}</span>
        </button>
        <button v-show="true" class="allNodeBtn" style="justify-content: flex-end;" @click="sortClick">
          <el-image
            style="width: 12px; height: 12px; margin-top: 5px; margin-right: 5px;"
            :src="sortStatus == null ? image1 : image2"
            fit="fill"></el-image>
          <span style="font-size: 13px;">排序</span>
        </button>
      </div>
      <el-tree :data="treeData" :show-checkbox="showCheckbox" :props="defaultProps" node-key="id" highlight-current
               :expand-on-click-node="false" @node-click="treeNodeClick" :filter-node-method="filterNode"
               :default-expanded-keys="defaultExpandedKeys" accordion :check-strictly="true" ref="SlotTree">
          <span class="custom-tree-node" slot-scope="{ node, data }" @contextmenu.prevent="rightShow(data)">
            <el-popover
              placement="right"
              trigger="manual"
              v-model="data.showChangeSn">
                <el-button size="small" @click="treeNodeTop(node, data)" plain>置顶</el-button>
                <el-button size="small" @click="treeNodeUp(node, data)" style="margin-left: 10px;" plain>上移</el-button>
                <el-button size="small" @click="treeNodeDown(node, data)" style="margin-left: 10px;" plain>下移</el-button>
                <span slot="reference" @blur="treeBlur(data)" v-if="data.hasOwnProperty('attributes') && data.attributes.hasOwnProperty('haveData') && data.attributes.haveData != null && data.attributes.haveData != '' && parseInt(data.attributes.haveData) > 0" style="font-size:14px; color: #339933;">
                    <i v-if="data.id != ''" style="color:#3b60d9" :class="[!!data.attributes?'el-icon-folder':'el-icon-files']"></i>{{ node.label }}
                </span>
                <span slot="reference" @blur="treeBlur(data)" v-else style="font-size:14px;">
                    <i v-if="data.id != ''" style="color:#3b60d9" :class="[!!data.attributes?'el-icon-folder':'el-icon-files']"></i>{{ node.label }}
                </span>
            </el-popover>
          </span>
      </el-tree>
    </el-main>
  </el-container>
</template>

<script>
  import {changeSn, changeSnEnd} from "../../api/processApproval";

  export default {
    name: "ResourcePageTree",
    props: {
        treeData: {
          type: Array,
          default: () => []
        },
        showCheckbox: {
          type: Boolean,
          default: false
        },
        projectId: {
          type: String,
          default: ''
        },
        setCheck: {
          type: Boolean,
          default: false
        },
        directoryId: {
          type: String,
          default: ''
        },
      },
    data() {
        return {
          filterText: "",
          defaultProps: {
            children: "children",
            label: "text"
          },
          chooseTreeNode: {},
          defaultExpandedKeys: [],
          allNode: null,
          showAll: false,
          allText: '',
          sortStatus: null,
          defaultAllNode: undefined,
          image1: require('@/assets/icon_sort_ascend.png'),
          image2: require('@/assets/icon_sort_descend.png'),
        };
      },
    created() {
        //配置是否默认选中全部
        this.defaultAllNode = this.$route.query.defaultAllNode;
      },
    mounted: function() {
        if (this.treeData.length > 0) {
          const id = sessionStorage.getItem("pagetreenodeid");
          if (!!id) {
            const item = this.findNode(this.treeData, id);
            if (item) {
              this.treeNodeClick(item);
              return;
            }
          }
          this.treeNodeClick(this.treeData[0]);
        }
      },
    watch: {
        treeData: {
          handler: function(value) {
            if (this.showCheckbox && this.setCheck) {
              value.forEach(row => {
                this.handleSetCheckData(row);
              })
            }
            if (value.length > 0) {
              if (value[0].id === '') {
                this.allNode = value[0];
                this.showAll = true;
                this.allText = value[0].text;
                value.splice(0, 1);
              }

              if (value.length > 0) {
                let id;
                if (this.directoryId) {
                  id = this.directoryId;
                } else {
                  id = sessionStorage.getItem("pagetreenodeid");
                }

                if (!!id) {
                  const item = this.findNode(value, id);
                  if (item) {
                    this.treeNodeClick(item);
                    return;
                  }
                }
                if (!!this.defaultAllNode) {
                  this.allNodeClick();
                } else {
                  this.treeNodeClick(value[0]);
                }
              } else {
                this.allNodeClick();
              }
            }
          }
        }
      },
    methods: {
        treeNodeClick(node) {
          if (!node) {
            this.$emit("treeInfo", node);
            return;
          }
          this.chooseTreeNode = node;
          if (this.showAll) {
            sessionStorage.setItem("pagetreenodeid", node.id);
          }
          this.$nextTick(() => {
            this.defaultExpandedKeys = [node.id];
            this.$refs.SlotTree.setCurrentNode(node);
          });

          this.$emit("treeInfo", node);
        },
        findNode(arr, id) {
          for (var i = 0; i < arr.length; i++) {
            const item = arr[i];
            if (item.id == id) {
              return item;
            }
            if (item.children) {
              const temp = this.findNode(item.children, id);
              if (temp) {
                return temp;
              }
            }
          }
          return null;
        },
        treeFilter() {
          this.$refs.SlotTree.filter(this.filterText);
        },
        filterNode(value, data) {
          if (!value) return true;
          return data.text.indexOf(value) !== -1;
        },
        getCheckedNodes() {
          return this.$refs.SlotTree.getCheckedNodes();
        },
        clearCurrent() {
          this.$refs.SlotTree.setCurrentKey(null);
        },
        handleSetCheckData(data) {
          if (data.attributes.projectId === this.projectId) {
            data.disabled = true;
          }
          if (data.children != null) {
            data.children.forEach(row => {
              this.handleSetCheckData(row);
            })
          }
        },
        allNodeClick() {
          this.$refs.SlotTree.setCurrentKey(null);
          this.$emit("treeInfo", this.allNode);
        },
        sortClick() {
          if (!!this.sortStatus) {
            this.sortStatus = null;
          } else {
            this.sortStatus = 'desc';
          }
          this.$emit("sortTree", this.sortStatus);
        },
        rightShow(data) {
          if (data.disabled) return;

          if (data.showChangeSn == null) {
            data.showChangeSn = true;
          } else {
            data.showChangeSn = !data.showChangeSn;
          }
        },
        treeBlur(data) {
          data.showChangeSn = false;
        },
        treeNodeTop(node, data) {
          data.showChangeSn = false;
          let parentNode = node.parent;
          let index = parentNode.childNodes.indexOf(node);
          if (index === 0) {
            this.$message('已是最顶级!');
            return;
          }

          let params = {
            id: data.id,
            select: 'up'
          };

          changeSnEnd(this.$qs.stringify(params)).then(res => {
            if (res.success) {
              let parentNode = node.parent;

              this.$refs.SlotTree.remove(node);
              this.$refs.SlotTree.insertBefore(data, parentNode.childNodes[0]);
            } else {
              this.$message.error('上一级是默认节点，不可移动!');
            }
          }).catch(error => { console.log(error) });
        },
        treeNodeUp(node, data) {
          data.showChangeSn = false;
          let parentNode = node.parent;

          let index = parentNode.childNodes.indexOf(node);
          if (index === 0) {
            this.$message('已是最顶级，无法上移!');
            return;
          }

          this.reqChangeSn(data.id, 'up', node, data);
        },
        treeNodeDown(node, data) {
          data.showChangeSn = false;
          let parentNode = node.parent;

          let index = parentNode.childNodes.indexOf(node);
          if (index === (parentNode.childNodes.length - 1)) {
            this.$message('已是最下级，无法下移!');
            return;
          }

          this.reqChangeSn(data.id, 'down', node, data);
        },
        reqChangeSn(id, select, node, data) {
          let params = {
            id: id,
            select: select
          };

          changeSn(this.$qs.stringify(params)).then(res => {
            if (res.success) {
              let parentNode = node.parent;
              let index = parentNode.childNodes.indexOf(node);

              this.$refs.SlotTree.remove(node);
              if (select == 'up') {
                this.$refs.SlotTree.insertBefore(data, parentNode.childNodes[index - 1]);
              } else if (select == 'down') {
                this.$refs.SlotTree.insertAfter(data, parentNode.childNodes[index]);
              }
            } else {
              if (select == 'up') {
                this.$message.error('上一级是默认节点，不可移动!');
              } else if (select == 'down') {
                this.$message.error('下一级是默认节点，不可移动!');
              }
            }
          }).catch(error => { console.log(error) });
        }
      }
  }
</script>

<style scoped>
  .padding-content {
    padding: 4px 0;
  }
</style>

<style>
  .about {
    padding: 10px 0 0 0;
    height: calc(100vh - 0px);
  }

  #cContent {
    height: 100%;
    padding: 0;
    margin: 0;
    /*overflow: auto;*/
  }

  #elInput {
    margin-left: 1px;
    margin-right: 1px;
    margin-bottom: 10px;
  }
  .comp-tree::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }
  .comp-tree::-webkit-scrollbar-thumb {
    background-color: rgba(50, 65, 87, 0.5);
    outline: 1px solid slategrey;
    border-radius: 2px;
  }
  .comp-tree::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .rptTopButtonDiv {
    display: flex;
    justify-content: space-between;
  }
  .allNodeBtn {
    width: 40%;
    height: 26px;
    line-height: 24px;
    color:#606266;
    display: flex;
    padding-left: 10px;
    background: white;
    border: none;
    outline: none;
    cursor: pointer;
  }
</style>

<style lang="less">
  .comp-tree {
    width: 100%;
    height: calc(100% - 55px);
    padding: 0;
    overflow: auto;
    .el-tree > .el-tree-node {
      display: inline-block;
      min-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/todo/ResourcePageTree.vue